export default __webpack_public_path__ + "static/media/11.97ddbd5e.svg";